<template>
  <el-dialog
    append-to-body
    width="900px"
    title="修改工资表规则"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <p>1、更新流程：下载结算表→修改薪资数据→点击上传→提交后预览检查</p>
    <p>
      2、注意以下数据以系统为准，不支持表格修改：单位名称、姓名、基本工资、个人或单位五险（除外补缴）、个人或单位公积金（补缴除外）、雇主责任险、应发工资、管理费、税点、开票金额、个税、垫付、实发工资以及其他员工个人和收款信息
    </p>
    <p>3、工资表手动增加字段使用不同符号的作用：</p>
    <p>①加符号@：表示该字段会计入计税金额，字段放在计税金额前雇主责任险后；</p>
    <p>
      ②加符号+：
      表示该字段会计入应发金额（也会自动计入开票金额），放在计税金额后
      应发工资前；
    </p>
    <p>③字段加#：表示该字段会计入开票金额，放在开票金额前 管理费后</p>
    <p>
      ④加2个符号：如要计入开票和计税 可以加#@；如要计入应发和计税
      字段可以加+@（由于应发会自动计入开票，故这两个符号也等于应发计税和开票都会影响）
    </p>
    <p>
      ⑤退税不加符号：实发前面增加退税字段影响实发和应发，不影响开票和计税：
      工资结算-待确认-下载工资表-在实发前面手动增加一列
      输入退税，内容填正数实发工资会增加，填负数实发工资会扣除
    </p>
    <p>4、备注：</p>
    <p>
      ①1个字段增加2个符号的符号顺序随便放，影响多个字段的，就放在最先要影响的字段（计税金额、应发金额、开票金额）前面
    </p>
    <p>
      ②鹰潭分公司创建五险不需要设置大病医疗险，针对要缴纳的员工在当月工资表直接插入一列字段及数据即可
    </p>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>
<style scoped lang="scss">
</style>
